
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class InvoiceDetails extends Vue {
	@Prop({ type: Object, required: true }) details!: Record<string, string>;

	onEdit() {
		this.$emit('edit', 0);
	}

	isLink(name: string) {
		return (
			name.toLowerCase() === 'external invoice link' &&
			this.$route.params.id
		);
	}
}
